export default __webpack_public_path__ + "static/media/Skeleton-3D-Model-Rigged-03.9f47014f.jpg";